<div id="refreshConnectionTab" class="one temp-height height-525 overflow-auto">
  <mat-icon
    class="icon-btn refresh-btn disply-block"
    id="refreshConnectionTab"
    (click)="refreshConnectionTab()"
  >
    refresh
  </mat-icon>
  <div class="gap-2em flex flex-wrap">
    @for (connection of ConnectionData; track connection; let i = $index) {
      <mat-card
        appearance="outlined"
        class="grid-col-3 cardblock flex flex-col p-15"
        (click)="setIndex(i)"
        [ngClass]="selectedIndex == i && connection.STATUS !== 'Inactive' ? 'active' : ''"
        [ngClass]="connection.STATUS == 'Inactive' ? 'disabled' : ''"
      >
        <div class="topheader-block mb-3 flex items-center justify-between">
          <div class="flex items-start gap-10">
            <span class="w-[50px]">
              <img class="verified-logo" src="assets/icons/web_app/{{ connection.ICON }}" />
            </span>
            <span class="badge-block">{{ connection.TOKENTYPE }}</span>
          </div>
          <div class="text-primary-50">
            @if (connection.STATUS == 'Connected') {
              <svg
                class="verified-ic"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
                fit
                height="100%"
                width="100%"
                preserveAspectRatio="xMidYMid meet"
                focusable="false"
              >
                <path
                  fill-rule="evenodd"
                  d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            }
            @if (connection.STATUS !== 'Connected') {
              <svg
                class="verified-ic pointer-cursor"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.353 3.549C8.77496 3.06223 9.29673 2.67196 9.88287 2.40468C10.469 2.13741 11.1058 1.99939 11.75 2C13.107 2 14.323 2.6 15.147 3.549C15.7897 3.50311 16.4347 3.59609 17.0383 3.82161C17.6419 4.04713 18.1899 4.39992 18.645 4.856C19.1009 5.31106 19.4536 5.85888 19.6791 6.46226C19.9046 7.06564 19.9977 7.71047 19.952 8.353C20.4386 8.77505 20.8287 9.29686 21.0958 9.883C21.3629 10.4691 21.5007 11.1059 21.5 11.75C21.5006 12.3942 21.3626 13.031 21.0953 13.6171C20.828 14.2033 20.4378 14.725 19.951 15.147C19.9967 15.7895 19.9036 16.4344 19.6781 17.0377C19.4526 17.6411 19.0999 18.1889 18.644 18.644C18.1889 19.0999 17.6411 19.4526 17.0377 19.6781C16.4344 19.9036 15.7895 19.9967 15.147 19.951C14.725 20.4378 14.2033 20.828 13.6171 21.0953C13.031 21.3626 12.3942 21.5006 11.75 21.5C11.1058 21.5006 10.469 21.3626 9.88287 21.0953C9.29673 20.828 8.77496 20.4378 8.353 19.951C7.71038 19.997 7.06538 19.9042 6.46181 19.6789C5.85824 19.4535 5.31023 19.1009 4.855 18.645C4.39897 18.1898 4.04622 17.6419 3.8207 17.0383C3.59518 16.4347 3.50218 15.7897 3.548 15.147C3.06141 14.7249 2.67133 14.2031 2.40423 13.617C2.13713 13.0309 1.99927 12.3941 2 11.75C2 10.393 2.6 9.177 3.549 8.353C3.50326 7.71047 3.5963 7.06562 3.82182 6.46222C4.04734 5.85883 4.40005 5.31103 4.856 4.856C5.31103 4.40005 5.85883 4.04734 6.46222 3.82182C7.06562 3.5963 7.71047 3.50326 8.353 3.549ZM15.36 9.936C15.42 9.85605 15.4634 9.76492 15.4877 9.66795C15.512 9.57098 15.5166 9.47014 15.5014 9.37136C15.4861 9.27257 15.4513 9.17783 15.3989 9.0927C15.3465 9.00757 15.2776 8.93378 15.1963 8.87565C15.1149 8.81753 15.0228 8.77624 14.9253 8.75423C14.8278 8.73222 14.7269 8.72992 14.6285 8.74746C14.5301 8.76501 14.4362 8.80205 14.3523 8.85641C14.2684 8.91077 14.1962 8.98135 14.14 9.064L10.904 13.594L9.28 11.97C9.13783 11.8375 8.94978 11.7654 8.75548 11.7688C8.56118 11.7723 8.37579 11.851 8.23838 11.9884C8.10097 12.1258 8.02226 12.3112 8.01883 12.5055C8.0154 12.6998 8.08752 12.8878 8.22 13.03L10.47 15.28C10.547 15.3569 10.6398 15.4162 10.742 15.4536C10.8442 15.4911 10.9533 15.5059 11.0618 15.4969C11.1702 15.488 11.2755 15.4555 11.3701 15.4019C11.4648 15.3482 11.5467 15.2745 11.61 15.186L15.36 9.936Z"
                  fill="#FF0000"
                />
                <rect x="6" y="8" width="11" height="10" fill="#FF0000" />
                <path
                  d="M8.95461 8.00009C8.8732 8.00009 8.7917 8.0311 8.72965 8.0933L8.0933 8.72965C7.9689 8.85406 7.9689 9.05548 8.0933 9.17957L10.4137 11.5L8.0933 13.8204C7.9689 13.9448 7.9689 14.1463 8.0933 14.2703L8.72965 14.9067C8.85406 15.0311 9.05548 15.0311 9.17957 14.9067L11.5 12.5863L13.8204 14.9067C13.9445 15.0311 14.1463 15.0311 14.2703 14.9067L14.9067 14.2703C15.0311 14.1459 15.0311 13.9445 14.9067 13.8204L12.5863 11.5L14.9067 9.17957C15.0311 9.05548 15.0311 8.85374 14.9067 8.72965L14.2703 8.0933C14.1459 7.9689 13.9445 7.9689 13.8204 8.0933L11.5 10.4137L9.17957 8.0933C9.11737 8.0311 9.03602 8.00009 8.95461 8.00009Z"
                  fill="white"
                />
              </svg>
            }
          </div>
          <!-- <img  src="../../../../../assets/images/logos/cross.svg"> -->
        </div>
        <mat-card-header class="mb-3 p-0">
          <mat-card-title class="text-ellipsis">{{ connection.TITLE }}</mat-card-title>
        </mat-card-header>
        <mat-card-content class="space-y-3 p-0">
          <p>{{ connection.DESCRIPTION }}</p>
          <!-- / <p>sasdsd</p> -->
          <div class="mb-4 flex flex-col gap-10">
            @if (connection.DATECONNECTED || connection.TIMECONNECTED) {
              <div class="flex items-center gap-1.5">
                <mat-icon class="flex size-[18px] shrink-0 items-center justify-center text-xl">
                  watch_later
                </mat-icon>
                <strong class="pr-4">Connected</strong>
                {{ connection.DATECONNECTED }}
                {{ connection.TIMECONNECTED }}
              </div>
            }
            @if (connection.DATEREFRESHED || connection.TIMEREFRESHED) {
              <div class="flex items-center gap-1.5">
                <mat-icon class="flex size-[18px] shrink-0 items-center justify-center text-xl">
                  access_time
                </mat-icon>
                <strong class="pr-10">Refreshed</strong>
                {{ connection.DATEREFRESHED }}
                {{ connection.TIMEREFRESHED }}
              </div>
            }
          </div>
        </mat-card-content>
        <mat-card-footer
          class="relative -mx-15 mt-auto -mb-15 flex justify-end bg-[#00800014] px-[1.5rem] py-4"
        >
          <mat-progress-bar
            mode="determinate"
            class="progress-wrap absolute top-0 left-0 w-full"
            value="40"
          ></mat-progress-bar>
          @if (connection.STATUS !== 'Inactive') {
            <button
              mat-stroked-button
              (click)="DeleteConnection(connection, i)"
              class="!rounded-full"
            >
              <span class="flex items-center gap-2">
                <span>
                  {{ connection.STATUS === 'Disconnected' ? 'Connect' : 'Disconnect' }}
                </span>

                <mat-icon>arrow_right_alt</mat-icon>
              </span>
            </button>
          }
        </mat-card-footer>
      </mat-card>
    }
  </div>
</div>
